import React from 'react';
import {Box, CircularProgress} from '@mui/material';

/**
 * Suspense fallback for lazily-loaded route features.
 *
 * Deliberately minimal: the chunk it is waiting on is usually already warm in the
 * service-worker cache, so anything heavier than a centered spinner flashes.
 *
 * @return {React.ReactElement} Centered loading spinner.
 */
function RouteFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export {RouteFallback};
